"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parser = void 0;
const pegjs_1 = __importDefault(require("pegjs"));
// The grammar is a raw string so not to escape backslashes, which can be confusing in the grammar
const EBTS_GRAMMAR = String.raw `
{
  // We use RecordTypes to accumulate the list of Record Types from the Table of Contents when the Type-1 record is
  // parsed. Then while parsing image records we use CurrRecordType to determine *how* they should be parsed.
  let RecordTypes = [];
  let CurrRecordType;

  let CurrLen;  // Length of current binary record being parsed
  let CurrPos;  // Current position used for parsing fixed-legnth byte sequences
  let CurrRecordStart; // For Type-9 and up records, this points to the start of the record
  let CurrIDC; // For Type-9 and up records, this holds the IDC
}

Records =
  type_1:Type1Record type_2:Type2Record images:ImageRecord* {
    return [ type_1, type_2].concat(images);
  }

Record =
  fields:Field+ RecordSeparator { return { fields }; }

Type1Record = 
  record:Record {
    // The field 1.03 is always the table of contents, we store it for scanning the binaries later.
    // Note that we remove the first two entriess, the ones for Type-1 and Type-2 records.
    const toc = record.fields.find(f => f.index == '1.03');
    if (!toc) { error("Missing Table of Contents field 1.03."); } // This would be very unexpected
    RecordTypes = toc.instances.map(i => Number(i[0]));
    RecordTypes.shift();
    RecordTypes.shift();
    return { recordType: 1, ...record };
  }

Type2Record = 
  record:Record { return { recordType: 2, ...record }; }

Field =
  index:DFIndex instances:Instances* FieldSeparator? { return { index, instances }; }

Instances =
  subfields:SubField+ InstanceSeparator? { return subfields; }
  /
  InstanceSeparator { return ''} // Empty item to fix first empty item for T2_SORI

SubField =
  sf:[^\x1C\x1D\x1F\x1E]+ SubFieldSeparator? { return sf.join(''); }
  /
  SubFieldSeparator { return ''} // Empty sub-field

DFIndex =
  [0-9]+ "." [0-9]+  ":" { return text().slice(0, -1); }  // Remove terminating ':'

SubFieldSeparator =
  [\x1F] { return text(); }

InstanceSeparator =
  [\x1E] { return text(); }

FieldSeparator =
  [\x1D] { return text(); }

RecordSeparator =
  [\x1C] { return null; }

ImageRecord =
  ('' { CurrRecordType = RecordTypes.shift(); } )
  // Full binary fingerprint Record Type
  &{ return CurrRecordType >= 3 && CurrRecordType <= 7 } rec:Type3_to_7ImageRecord { return rec; }
  /
  // Full binary signature Record Type
  &{ return CurrRecordType == 8 } rec:Type8ImageRecord { return rec; }
  /
  // Mixed text/binary image Record Type
  &{ return CurrRecordType >= 9 } rec:Type9_and_UpImageRecord { return rec; }

Type3_to_7ImageRecord =
  length:Length idc:IDC type:Byte fingerPositions:FingerPositions resolution:Byte width:Word height:Word compression:Byte image:ByteSequence {
    return { recordType: CurrRecordType, idc, length, type, fingerPositions, resolution, width, height, compression, image };
  }

Type8ImageRecord =
  length:Length idc:IDC type:Byte representation:Byte resolution:Byte width:Word height:Word image:ByteSequence {
    return { recordType: CurrRecordType, idc, length, type, representation, resolution, width, height, image };
  }

Type9_and_UpImageRecord =
  fields:FieldNot999+ idx:DFIndex999 image:ByteSequence {
    return { recordType: CurrRecordType, idc: CurrIDC, fields, image };
  }

// In Type-9 and above records, the field ending in .001 (the first field) identifies the total record length and the
// field ending in .999 (the last field) identifies the binary image data.
FieldNot999 =
  fld:Field &{ return !fld.index.endsWith("999"); } {
    if (fld.index.endsWith("001")) {
      // We have the start of this record, and the length of the entire record. Once we get to the binary field (*.999),
      // we can subtract the text field lengths from CurrLen to get the effective image length.
      CurrRecordStart = location().start.offset;
      CurrLen = Number(fld.instances[0][0]);
    } else if (fld.index.endsWith("002")) {
      // The IDC resides here, for Type-9 and above records
      CurrIDC = fld.instances[0][0];
    }
    return fld;
  }

DFIndex999 =
  idx:DFIndex &{ return idx.endsWith("999"); } {
    // Get real image length by removing the lengths of all the text fields encountered since the start of the record.
    const lenTextFields = location().end.offset - CurrRecordStart;
    CurrLen -= lenTextFields;
  }

FingerPositions =
  fgp1:Byte fgp2:Byte fgp3:Byte fgp4:Byte fgp5:Byte fgp6:Byte

Length =
  len:DoubleWord {
    // Subtract the standard 18 byte fingerprint image header or 12 byte signature header.
    CurrLen = len - (CurrRecordType == 8 ? 12 : 18);
    return CurrLen;
  }

ByteSequence =
  ('' { CurrPos = 0; }) NextByte* { return Buffer.from(text(), 'binary').toString('base64'); }

NextByte =
  &{ return CurrPos++ < CurrLen; } Byte;

IDC =
  // The Image Designation Character is always expressed as a 2 digit, 0-padded string.
  b:Byte { return b.toString().padStart(2, 0); }

DoubleWord =
  w1:Word w2:Word { return (w1 << 16) + w2; }

Word =
  b1:Byte b2:Byte { return (b1 << 8) + b2; }

Byte =
  x:. { return x.charCodeAt(0); }
`;
const parser = pegjs_1.default.generate(EBTS_GRAMMAR);
exports.parser = parser;
//# sourceMappingURL=ebts-parser.js.map